import { type ComputedRef, computed } from 'vue'

export interface InputRangeTwoKnobbedStyle {
    styleSelectedClampSpacerLeft: ComputedRef<string>
    styleSelectedClampSpacerRight: ComputedRef<string>
}

export function useInputRangeTwoKnobbedStyle(
    minFinal: ComputedRef<number>,
    rangeClamped: ComputedRef<number>,
    valueMinUi: ComputedRef<number>,
    valueMaxUi: ComputedRef<number>
): InputRangeTwoKnobbedStyle {
    const valSorted = computed(
        (): [number, number] =>
            [valueMinUi.value, valueMaxUi.value].sort((a, b) => a - b) as [
                number,
                number,
            ]
    )

    const selectedClampPercentLeft = computed(
        () => ((valSorted.value[0] - minFinal.value) / rangeClamped.value) * 100
    )

    const selectedClampPercentRight = computed(
        () =>
            100 -
            ((valSorted.value[1] - minFinal.value) / rangeClamped.value) * 100
    )

    const styleSelectedClampSpacerLeft = computed(
        () => `flex: 0 0 ${selectedClampPercentLeft.value}%`
    )

    const styleSelectedClampSpacerRight = computed(
        () => `flex: 0 0 ${selectedClampPercentRight.value}%`
    )

    return {
        styleSelectedClampSpacerLeft,
        styleSelectedClampSpacerRight,
    }
}
